<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Preface</div><v-divider class="div-after"/>
    <div class="body-1">This post covers some of my graphics work prior to enrolling in CSCI-711, 
      RIT's Global Illumination course. The work here was completed in parallel with some basic
      OpenGL work in CSCI-610.</div>
    

    <v-divider class="spacer"/><div class="headline font-weight-bold">Fall 2018 Work</div><v-divider class="div-after"/>
    <div class="body-1">Back in Fall 2018, I came across the book 
      <a href="https://github.com/petershirley/raytracinginoneweekend">"Ray Tracing in One Weekend" 
      by Peter Shirley</a>. I had taken interest in ray-based rendering earlier
      during my intro graphics course, and this seemed like a really friendly opportunity to delve 
      into the underlying concepts of ray tracing! In retrospect, I realize that the book is perhaps a little
      misleading given that the title says "Ray Tracing" but it's actually going over path tracing,
      though I believe this is mentioned in the book early on. In any case, it was a great introduction
      to the maths and fundamental concepts behind a ray-based renderer. 
    </div>
    <div class="body-1">
      I wanted to focus on the fundamental concepts and underlying math prior to 
      jumping into any intense design or performance related work. Peter's book is a fantastic
      resource for this, since it takes us through a software-based renderer with plenty of areas
      to experiment with or extend. It didn't take long at all to get up and running with this!
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/0/ch6.png`)"/>
      <div class="font-weight-medium">Early render of a sphere!</div>
    <div class="body-1">
      Sadly I didn't get to finish up my work on this, as a few class projects cropped up towards
      the end of october, but I did get diffuse materials working! Almost...
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/0/almost.png`)"/>
      <div class="font-weight-medium">Uh oh, something is wrong here...</div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">CSCI-711 Ray Tracer</div><v-divider class="div-after"/>
    <div class="body-1">A significant portion of my work this semester revolves around the implementation
      of a software-based ray tracer that is capable of reproducing the following image. 
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/0/whitted.png`)"/>
      <div class="font-weight-medium">Whitted, 1980</div>
    <div> This image originates from Turner Whitted's efforts in 1980 to represent a three-dimensional 
      scene by taking into account both local and global illumination, which culminated in the paper 
      "<a href="https://dl.acm.org/citation.cfm?id=358882">An Improved Illumination Model for Shaded 
      Display</a>". It's actually quite a brief and understandable paper, which is always nice! :) 
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">What's Next?</div><v-divider class="div-after"/>
    <div class="body-1">CSCI-711 provides plenty of freedom for creating a software-based ray tracer.
      There are a number of potential extensions that we'll be allowed to implement in our system, 
      though I'd personally love to experiment with hardware acceleration using OpenCL or CUDA! 
    </div>

  </div>
</template>

<script>

export default {
  name: 'U_0',
  data() {
    return {
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[0];
    },
  }
};
</script>